export default {
  notifications: {
    title: "Alerts",
    markingAll: "Marking…",
    markAllRead: "Mark all as read",
    loading: "Loading…",
    empty: "You have no alerts.",
    clickToMark: "Click to mark as read",
    now: "Just now",
    minutesAgo: "{n} min ago",
    hourAgo: "{n} hour ago",
    hoursAgo: "{n} hours ago",
    yesterday: "Yesterday",
    daysAgo: "{n} days ago",
    dateLocale: "en-US",
  },
};
